import React, {Component} from 'react';

import './hiddenParagraph.scss';


class HiddenParagraph extends Component{

    constructor(props){
        super(props);

        this.state = {
            isOpen: false ,
            btnText:'קרא עוד',
            check:true
        }

        this.handleBtnClick = this.handleBtnClick.bind(this);

        this.frontRef = React.createRef();
        this.backRef = React.createRef();
    }

    handleBtnClick(){
        const open = !this.state.isOpen;
        if (this.state.btnText === 'קרא עוד')
            this.setState({isOpen: open, btnText: 'הסתר', check: false});
        else
            this.setState({isOpen: open, btnText: 'קרא עוד', check: false});

    }


    render(){

        const {
            className = '',
            paragraph = ''
        } = this.props;

        let nesseccaryBtn = true;

        if(this.backRef.current !== null && this.frontRef.current !== null && this.state.check ) {
            nesseccaryBtn = this.backRef.current.clientHeight > this.frontRef.current.clientHeight;
        }


        return(
            <section className='hiddenParagraph'>
                <div className={'front ' + (this.state.isOpen ? 'open' : '')}  ref={this.frontRef}>
                    <div className='back' ref={this.backRef}>
                        {paragraph}
                        <div className={className}>{this.props.children}</div>
                    </div>
                    {nesseccaryBtn &&
                    <div className={(this.state.isOpen ? '' : 'fading')}/>
                    }
                </div>
                {nesseccaryBtn &&
                <span className='btn' onClick={this.handleBtnClick}>{this.state.btnText}</span>
                }
            </section>
        )
    }
}

export default HiddenParagraph;